import { render, staticRenderFns } from "./btn-quarternary3.vue?vue&type=template&id=df489fd2&scoped=true&"
import script from "./btn-quarternary3.vue?vue&type=script&lang=js&"
export * from "./btn-quarternary3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df489fd2",
  null
  
)

export default component.exports